import { useCallback, useState } from 'react';
import { useDebounce } from 'react-use';

import { SectionReportNameProps } from './SectionReportName.types';

export const useSectionReportName = (
    reportConfig: SectionReportNameProps['reportConfig'],
    onReportConfigChange: SectionReportNameProps['onReportConfigChange']
) => {
    const [reportName, handleChangeReportName] = useState(reportConfig.name);

    const changeReportConfig = useCallback(
        (name: string) => {
            onReportConfigChange({ ...reportConfig, name });
        },
        [onReportConfigChange, reportConfig]
    );

    useDebounce(() => changeReportConfig(reportName), 200, [changeReportConfig, reportName]);

    return {
        reportName,
        handleChangeReportName,
    };
};
